module.exports = __webpack_public_path__ + "img/13.34d4e2b0.webp";